<ng-template #defaultPrefixTemplate let-row>
  <div class="prefix" [style.background-color]="row[options.indicatorColorProperty]"></div>
</ng-template>

<ng-template #defaultCardTemplate let-row>
  <div class="table-row-card">
    @if (row[options.titleProperty]) {
    <mat-label class="card-title" [ngClass]="options.stylePropertyPrefix + '-card-table-title'">
      {{ row[options.titleProperty] }}
    </mat-label>
    }

    @if (row[options.subTitleProperty]) {
    <mat-label class="card-sub-title" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-title'">
      {{ row[options.subTitleProperty] }}
    </mat-label>
    }

    @if (row[options.additionalProperty]) {
    <mat-label class="card-additional" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-additional'">
      {{ row[options.additionalProperty] }}
    </mat-label>
    }

    @if (row[options.contentProperty]) {
    <p class="card-content" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-content'">
      {{ row[options.contentProperty] }}
    </p>
    }
  </div>
</ng-template>

<ng-template #defaultRowTemplate let-row>
  @if (isExpandable == false) {
  <div style="display: flex; justify-content: space-between;">
    @for (property of row | objectvalues | propertyclean: options; track property; let i = $index) {
    <div [style.width]="headers != null && headers[i] != null ? headers[i]?.Width + '%' : 'auto'"
      [ngClass]="options.stylePropertyPrefix + '-card-table-row-prop-' + property.key">

      @if (property.value == null) {
      <mat-label>-</mat-label>
      }

      @if (property.value != null && headers[i]?.Type != 'tooltipCircle') {
      @if(property.value != null && headers != null && headers[i] != null && headers[i].Icon != null && headers[i]?.Icon
      != '') {
      @if(headers[i].Wrapper){
      @if(headers[i].Wrapper(property) == true){
      <mat-label [style.width]="'100%'"
        [style.cursor]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'pointer' : ''"
        [style.text-decoration]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'underline' : ''"
        (click)="handleRowItemClick(headers[i])" (mousedown)="mouseDown()" class="table-row-list-item ellipsis"
        [matTooltip]="headers[i]?.TooltipText ?? ''" [matTooltipPosition]="'above'"
        [ngClass]="['action-card-prop-' + property.key, options.textSize]">
        <mat-icon>{{headers[i].Icon}}</mat-icon>
      </mat-label>
      }
      }
      }
      }

      @if(headers[i]?.Wrapper == null && headers[i]?.Icon){
      <mat-label [style.width]="'100%'"
        [style.cursor]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'pointer' : ''"
        [style.text-decoration]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'underline' : ''"
        (click)="handleRowItemClick(headers[i])" (mousedown)="mouseDown()" class="table-row-list-item ellipsis"
        [matTooltip]="headers[i]?.TooltipText ?? ''" [matTooltipPosition]="'above'"
        [ngClass]="['action-card-prop-' + property.key, options.textSize]">
        <mat-icon>{{headers[i].Icon}}</mat-icon>
      </mat-label>
      }

      @if((headers[i] == null || headers[i].Icon == null) && headers[i]?.Type != 'tooltipCircle'){
      <mat-label [style.width]="'100%'"
        [style.cursor]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'pointer' : ''"
        [style.text-decoration]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null) ? 'underline' : ''"
        (click)="handleRowItemClick(headers[i])" (mousedown)="mouseDown()" class="table-row-list-item ellipsis"
        [matTooltip]="headers[i]?.TooltipText ?? ''" [matTooltipPosition]="'above'"
        [ngClass]="['action-card-prop-' + property.key, options.textSize]">
        <app-ellipsis [selectable]="(headers[i]?.OnClick != null || headers[i]?.OnDoubleClick != null)">
          {{ property.type == 'date' ? (property.value | date) : property.value }}</app-ellipsis>
      </mat-label>
      }

      @if (property.value != null && headers[i]?.Type == 'tooltipCircle') {
      <mat-label [style.width]="'100%'" class="table-row-list-item ellipsis"
        [ngClass]="['action-card-prop-' + property.key, options.textSize]">
        <span class="tooltipCircle" [style.background-color]="property.value.status ? '#3FC944' : '#C96D01'"
          matTooltip="{{ configureTooltip(headers[i], property) }}" matTooltipClass="tooltipClass"
          [matTooltipPosition]="headers[i]?.TooltipPosition"></span>
      </mat-label>
      }

    </div>
    }
    <div id="row-affix-wrapper">
      <ng-container #affix *ngTemplateOutlet="affixTemplate; context: {$implicit: row}"> </ng-container>
    </div>
  </div>
  }

  @if (isExpandable == true) {
  <div style="display: flex; justify-content: space-between;">
    <!-- <mat-stepper width="100%"> -->
    <mat-accordion style="width: 100%" value="colors">
      <mat-expansion-panel hideToggle class="accordion-panel mat-elevation-z0">
        <mat-expansion-panel-header style="padding: 0">
          <mat-panel-title style="margin: 0">
            @for (property of row | objectvalues | propertyclean: options; track property; let i = $index) {
            <div [style.width]="headers != null ? headers[i]?.Width + '%' : 'auto'"
              [ngClass]="options.stylePropertyPrefix + '-card-table-row-prop-' + property.key">
              @if (property.value == null) {
              <ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
              }
              @if (property.value != null && headers[i]?.Type != 'tooltipCircle') {
              <mat-label [style.width]="'100%'" class="table-row-list-item ellipsis"
                [ngClass]="['action-card-prop-' + property.key, options.textSize]">
                <app-ellipsis>
                  {{ property.type == 'date' ? (property.value | date) : property.value.toString() }}
                </app-ellipsis>
              </mat-label>
              }
              @if (property.value != null && headers[i]?.Type == 'tooltipCircle') {
              <mat-label [style.width]="'100%'" class="table-row-list-item ellipsis"
                [ngClass]="['action-card-prop-' + property.key, options.textSize]">
                <span class="tooltipCircle" [style.background-color]="property.value.status ? '#3FC944' : '#C96D01'"
                  matTooltip="{{ configureTooltip(headers[i], property) }}" matTooltipClass="tooltipClass"
                  [matTooltipPosition]="headers[i]?.TooltipPosition"></span>
              </mat-label>
              }
            </div>
            }
            <div id="row-affix-wrapper">
              <ng-container #affix *ngTemplateOutlet="affixTemplate; context: {$implicit: row}"> </ng-container>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if (row[dropDownDataKey] != null && row[dropDownDataKey].length > 0) {
        <mat-list slot="content">
          @for (link of row[dropDownDataKey]; track link; let i = $index) {
          <mat-list-item>
            @for (tag of expansionHeader; track tag; let indexTag = $index) {
            <mat-label [style.width]="tag.Width != null ? tag.Width + '%' : 'auto'">
              {{ link[tag.ID] }}
            </mat-label>
            @if (indexTag == expansionHeader.length - 1) {
            <div class="row-drop-actions">
              <ng-container #dropDownActions *ngTemplateOutlet="dropDownActionsTemplate; context: { $implicit: link }">
              </ng-container>
            </div>
            }
            }
          </mat-list-item>
          }
        </mat-list>
        }

        @if (row[dropDownDataKey] == null || row[dropDownDataKey].length == 0) {
        <mat-list slot="content">
          <mat-list-item>
            There is no data to display
          </mat-list-item>
        </mat-list>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  }
</ng-template>

<ng-template #defaultAffixTemplate let-row>
  @if (options.isSelectable) {
  <div class="vertical-wrapper actions-spacer">
    <mat-checkbox [checked]="isSelected"></mat-checkbox>
  </div>
  }
</ng-template>

<mat-list-item id="container" lines="none" (click)="selected()"
  [ngClass]="{ 'container-wide': layoutService.screenSize > breakpoint }">
  <div class="table-container" [style]="originalStyling && isSideNavCollapsed ? 'width: 90vw' : ''"
    [ngClass]="{'small-width': !isSideNavCollapsed && originalStyling}">
    <div [ngClass]="{ 'container-height': layoutService.screenSize <= breakpoint }"></div>
    <div id="row-prefix-wrapper" matTooltip="{{ row.$implicit.toolTip }}">
      <ng-container #prefix
        *ngTemplateOutlet="prefixTemplate != null ? prefixTemplate : defaultPrefixTemplate; context: row">
      </ng-container>
    </div>
    @if (layoutService.screenSize <= breakpoint || options.flexCardLayout===true) { <div id="card-content-wrapper"
      [ngClass]=" {'content': layoutService.screenSize <= breakpoint || options.flexCardLayout === true, 'clickable-card': options.clickableFlexCard === true}">
      <ng-container #cardContent *ngTemplateOutlet="cardTemplate != null ? cardTemplate : defaultCardTemplate;
          context: row">
      </ng-container>
  </div>
  }
  <div id="row-affix-wrapper">
    <ng-container #affix *ngTemplateOutlet="defaultAffixTemplate; context: row"></ng-container>
  </div>
  @if (layoutService.screenSize > breakpoint && options.flexCardLayout === false) {
  <div id="row-content-wrapper" class="content">
    <ng-container #rowContent *ngTemplateOutlet="rowTemplate != null ? rowTemplate : defaultRowTemplate; context: row">
    </ng-container>
  </div>
  }
  <!-- <div id="row-affix-wrapper">
      <ng-container #affix *ngTemplateOutlet="affixTemplate; context: row"> </ng-container>
    </div> -->
  </div>
</mat-list-item>
